import React from "react";

export default function Delete() {
  return (
    <div style={{ maxWidth: "700px", margin: "80px auto", padding: "20px" }}>
      <h1 style={{ marginBottom: "20px" }}>Delete Your EmployPilot Account</h1>

      <p>
        You may request deletion of your EmployPilot account and all associated 
        data at any time. We process these requests manually for security 
        verification.
      </p>

      <h2 style={{ marginTop: "30px" }}>How to Request Account Deletion</h2>
      <p>
        To request deletion of your account, please fill out the contact form 
        available on our website. This helps us verify your identity and confirm 
        the correct account for deletion.
      </p>

      <p>
        <strong>Go to the Contact Form:</strong>
      </p>
      <p>
        <a 
          href="/contact" 
          style={{ 
            color: "#3b82f6", 
            fontWeight: "bold", 
            textDecoration: "underline" 
          }}
        >
          https://employpilot.com/contact
        </a>
      </p>

      <p>When submitting your request, include:</p>
      <ul>
        <li>The email address associated with your EmployPilot account</li>
        <li>The subject line: <strong>Account Deletion Request</strong></li>
      </ul>

      <h2 style={{ marginTop: "30px" }}>What Happens When Your Account Is Deleted</h2>
      <ul>
        <li>Your EmployPilot user account will be permanently removed.</li>
        <li>
          All associated data will be deleted, except where retention is required 
          for fraud prevention, security, or legal compliance.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px" }}>Data That Will Be Deleted</h2>
      <ul>
        <li>Profile details</li>
        <li>Preferences</li>
        <li>Community access data</li>
        <li>AI tool usage history</li>
        <li>Any stored documents or uploads (if applicable)</li>
      </ul>

      <h2 style={{ marginTop: "30px" }}>Processing Time</h2>
      <p>Account deletion requests are processed within 3–5 business days.</p>
    </div>
  );
}
